import React from "react";
import styles from "../styles/Announcements.module.scss";
import { Image } from "@src/components/Image";
import { setAnnouncementsAttachedList } from "../store/actions";
import { getAwsAssets, hitHapticFeedback } from "@src/utils";
import { useDispatch } from "react-redux";
import { showAnnouncementsAttachments } from "@src/components/BottomSheets/store/actions.js";
import { useTranslation } from "react-i18next";

import ClipIcon from "../../../AccentIcons/ClipIcon";
import Linkify from "linkify-react";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";

const AnnouncedCard = ({ data }, ref) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDownloadAttachments = (data) => {
    dispatch(setAnnouncementsAttachedList(data));
    dispatch(showAnnouncementsAttachments(true));
  };

  const linkProps = {
    onClick: (e) => {
      e?.preventDefault();
      hitHapticFeedback();
      hitDeeplinkExecutedV2(
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        }),
        JSON.stringify({
          screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
          paramOne: e?.nativeEvent?.target?.innerText,
        })
      );
    },
  };

  return (
    <div className={styles.AnnouncedCard} ref={ref}>
      <div className={styles.AnnouncedCard__Header}>
        {new Date(data?.date)
          .toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })
          ?.replace(/ /g, " ")}
      </div>
      {data?.games?.map((data, i) => (
        <div className={styles.AnnouncedCard__Body} key={`${i}ann`}>
          <div className={styles.AnnouncedCard__Body__Left}>
            <Image
              src={getAwsAssets("comments.svg", "content")}
              className="SVGCoupons"
              height="20"
              width="20"
              alt="couponlist"
            />
          </div>
          <div className={styles.AnnouncedCard__Body__Right}>
            <div className={styles.AnnouncedCard__Body__Right__Description}>
              <Linkify options={{ attributes: linkProps }}>
                {data?.description}
              </Linkify>
            </div>
            <div className={styles.AnnouncedCard__Body__Right__Name}>
              {t(
                "components.tabs.Announcements.components.AnnouncedCard.by",
                "By "
              )}{" "}
              {data?.tutorName}
            </div>
            {data?.attachments?.length > 0 ? (
              <div className={styles.AnnouncedCard__Body__Right__Attachments}>
                <div
                  className={
                    styles.AnnouncedCard__Body__Right__Attachments__icon
                  }
                >
                  <ClipIcon />
                </div>
                <div
                  className={
                    styles.AnnouncedCard__Body__Right__Attachments__text
                  }
                  onClick={() => handleDownloadAttachments(data?.attachments)}
                >
                  {t(
                    "components.tabs.Announcements.components.AnnouncedCard.downloadAttachment",
                    "View Attachment"
                  )}{" "}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  );
};
const AnnouncedCardList = React.forwardRef(AnnouncedCard);
export default AnnouncedCardList;
